import type { Step } from "react-joyride";

export const zonesTourSteps: Step[] = [
  {
    target: "body",
    content:
      "ຍິນດີຕ້ອນຮັບສູ່ຫນ້າຈັດການໂຊນຄ່າສົ່ງ. ຫນ້ານີ້ຊ່ວຍທ່ານຈັດການໂຊນ (VTE, NEAR, FAR) ໄດ້.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="shipping-zones-toolbar"]',
    content: "ປຸ່ມສ້າງໂຊນໃໝ່. ກົດເພື່ອເພີ່ມໂຊນ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="shipping-zones-table"]',
    content:
      "ຕາຕະລາງໂຊນ. ສາມາດແກ້ໄຂລະຫັດ, ຊື່ 3 ພາສາ ແລະ ລຳດັບໄດ້ຈາກປຸ່ມການກະທໍາ.",
    placement: "top",
  },
];
